/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Copy_Id_TitleInputs */

const en_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy ID to clipboard`)
};

const fr_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier l'ID dans le presse-papiers`)
};

const de_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID in die Zwischenablage kopieren`)
};

const it_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia l'ID negli appunti`)
};

const ru_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать ID в буфер обмена`)
};

const es_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar ID al portapapeles`)
};

const zh_cn2_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制 ID 到剪贴板`)
};

const ja_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDをクリップボードにコピー`)
};

const hi_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आईडी को क्लिपबोर्ड पर कॉपी करें`)
};

const pt_pt2_explorer_info_copy_id_title = /** @type {(inputs: Explorer_Info_Copy_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar ID para a área de transferência`)
};

/**
* | output |
* | --- |
* | "Copy ID to clipboard" |
*
* @param {Explorer_Info_Copy_Id_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_title = /** @type {((inputs?: Explorer_Info_Copy_Id_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_copy_id_title(inputs)
	if (locale === "de") return de_explorer_info_copy_id_title(inputs)
	if (locale === "it") return it_explorer_info_copy_id_title(inputs)
	if (locale === "ru") return ru_explorer_info_copy_id_title(inputs)
	if (locale === "es") return es_explorer_info_copy_id_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_copy_id_title(inputs)
	if (locale === "ja") return ja_explorer_info_copy_id_title(inputs)
	if (locale === "hi") return hi_explorer_info_copy_id_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_copy_id_title(inputs)
	return en_explorer_info_copy_id_title(inputs)
});